import {types} from '../services/conjointAccessActions'

export default (state = {}, action) => {
	switch (action.type) {
		case types.LOG_USER: {
			if (action.payload) {
				return action.payload
			}
			return state
		}
		default:
			return state
	}
}
